

const initialState = {
    wdata: {}
};


const weather = (state = {}, action) => {
    switch (action.type) {
        case "STORE_WEATHER":
            return (
                state = action.payload
            );
        case "CHANGE_WEATHER":
            //   let posts = [...state]; // we're destructuring `state.posts` inside of array, essentially assigning the elements to a new array.
            //  posts.push(action.payload);
            return (
                
                state = action.payload
            );

        case "CLEAR_WEATHER":
            return state = null;

        default:
            return state;
    }
}
export default weather;